import { defineStore } from 'pinia'

export const useUiStore = defineStore('ui', {
  state: () => ({
    loading: false,
    sidebarVisible: true,
    sidebarUnfoldable: true,
    theme: 'light',
    modaisAbertos: [] as { modal: any, aoFechar: any | null }[],
    toasts: [] as Array<{ title?: string, content: string; color: string }>,
    modalInatividade: {
      exibir: false,
      tempoRestante: 0,
      tempoLimite: 30 * 60 * 1000, // 30 minutos
    },
  }),
}); 